<template>
  <div class="page-buycoin">
    <div class="otc-container-other">
      <top-bar />
      <router-view v-if="$route.name != 'coin'"></router-view>
    </div>
  </div>
</template>

<script>
import TopBar from '@/components/TopBar.vue';
export default {
  components: {
    TopBar
  }
};
</script>

<style lang="scss" scoped>
.page-buycoin {
  .otc-container-other {
    padding-top: 24px;
    //max-width: 1920px;
    //width: 1200px;
    margin: 0 auto;
    min-height: 960px;
   
  }
}
</style>
